/**
 * Real-time multiplayer asteroids game with TypeScript/Bun server and HTML5 Canvas client
 * Lobby domain - React-based Lobby Browser root component
 */

import type { LobbyMetadata } from "@game/domain";
import type React from "react";
import { useEffect, useMemo, useState } from "react";
import { Panel } from "../ui/Panel";
import { LobbyCardContainer } from "./LobbyCardContainer";

export const LobbyBrowser: React.FC = () => {
  const [lobbies, setLobbies] = useState<LobbyMetadata[]>([]);

  useEffect(() => {
    // Expose bridge for vanilla JS to update React state
    window.lobbyBridge = {
      updateLobbies: (newLobbies: LobbyMetadata[]) => {
        setLobbies(newLobbies);
      },
      setVisible: (_visible: boolean) => {
        // Handle visibility changes if needed
      },
    };

    return () => {
      delete window.lobbyBridge;
    };
  }, []);

  // Memoize sliced lobbies to prevent infinite re-renders in useLobbySimulation
  const visibleLobbies = useMemo(() => lobbies.slice(0, 3), [lobbies]);

  return (
    <Panel title="ACTIVE GAMES">
      <LobbyCardContainer lobbies={visibleLobbies} />
    </Panel>
  );
};
